// extracted by mini-css-extract-plugin
export default {"notification-list":"Notification_notification-list__cRv8N"};